'use client';
import FooterNav from '@modules/layout/components/footer-nav';
import './index.scss';
import { usePathname } from 'next/navigation';
import { routes } from '@lib/constants/routes-constant';
import { useMemo } from 'react';

const Footer = () => {
  const pathname = usePathname();
  const withoutFooter = useMemo(() => {
    return pathname.indexOf(routes.redemption) !== -1;
  }, [pathname]);

  return (
    <>
      {withoutFooter ? (
        <footer></footer>
      ) : (
        <footer className="footerMain">
          <FooterNav variant="dark" />
        </footer>
      )}
    </>
  );
};

export default Footer;
